import { observable } from "mobx";
import { secureService, settingService } from "../_services";
import i18n from 'i18next';
import { ILicense } from "../_types/interfaces";

const translate = (name: string) => i18n.t('setting.' + name);


export const secureStore = observable({
    isLoading: false,
    isNotification: false,
    code: "",
    codeServices: "",
    serverAddress: "",
    fullAddress: "",
    message: "",
    licenseServices: [] as Array<ILicense>,
    showMessage(message: string) {
        secureStore.message = message;
        secureStore.isNotification = true;
    },
    async loadSecureInfo() {
        secureStore.isLoading = true;
        try {
            let response = await secureService.getCode();
            secureStore.code = response;
            response = await secureService.getServicesCode();
            secureStore.codeServices = response;
            response = await secureService.getServerAddress();
            secureStore.serverAddress = response;
            secureStore.fullAddress = secureStore.serverAddress + '/' + secureStore.code + '/' + secureStore.codeServices;
            const array_response = await secureService.getLicensesForServices();
            secureStore.licenseServices = array_response;
            
        }
        catch (errors) {
            secureStore.showMessage(translate('notification.load_error'));
        }
        secureStore.isLoading = false;
    },
})